import { useMutation } from "@apollo/client";
import { ACTIVATE_CLOUDSPACE } from "graphql/mutations/transactions";
import { useState } from "react";
import { SAText } from "utils/functions";
import { validatePhoneNumber } from "utils/functions";
import { FormatPhone } from "utils/functions";

const { CardHeader, CardBody, CardFooter, Card, Col, Row, FormGroup, Input, Button } = require("reactstrap");

function Activation(){
  const [activationdata, setActivationData] = useState({
    phone:"",
    code: ""
  });

  const [step, setStep] = useState(1);
  const [fielderrors, setFieldError] = useState([]);
  const [setAppLoading] = useState();
  const [activateCloudSpace] = useMutation(ACTIVATE_CLOUDSPACE);

  const UpdateActivationData = (e, type = '') => {
    if(type !== "array"){
      let value = e.target.value;
      if(e.target.type === 'number'){
        if(value === '') value = 0;
        else value = parseInt(value);
      }
  
      if(type === 'boolean') {
        if(typeof(value) === "string"){
          const a = (value === 'true');
          value = a;
        }
      }
  
      setActivationData(prevState => {
        return { ...prevState, [e.target.name]: value};
      });
    }
    else{
      setActivationData(prevState => {
        return { ...prevState, [e.name]:e.value};
      });
    }
  };

  const CheckError = (e) =>{
    if(fielderrors.length > 0){
      const q = fielderrors.find((a)=>a.field === e);
      if(q) return q.error; else return false;
    }
    else return false;
  };

  const ActivateNow = () => {
    let valid = true;
    setFieldError(() => []);

    if(activationdata.code.trim() === "" || activationdata.code === undefined) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "code", error: "Activation Code is required"}]; });
    }

    if(!validatePhoneNumber(activationdata.phone)) {
      valid = false;
      setFieldError(prevState => { return [ ...prevState, {field: "phone", error: "Invalid Phone Format"}]; });
    }

    if(valid){
      setAppLoading(true);
      activateCloudSpace({ variables: { phone: activationdata.phone, code: activationdata.code} })
      .then( (actres) => {
        if(actres.data.activateCloudSpace.status){
          SAText("Success", "Successfully Activated Cloud Storage", "success");
          setStep(2);
        }
        else{
          SAText("Error", actres.data.activateCloudSpace.error, "error");     
        }
      })
      .catch( (err2) => {
        SAText("Error", err2, "error");
      })
      .finally(() => {
        setAppLoading(false);
      });
    }
  };

  return (
    <div className="content">
    <Row>
        <Col md="12">
          <Card>
            <CardHeader className='subTitle'>Cloud Storage Activation</CardHeader>
          
          {step === 1 &&
            <CardBody>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <label className="subTitle">* Phone:</label>
                    <Input
                      placeholder="Phone"
                      type="text"
                      name="phone"
                      value={activationdata.phone}
                      onChange={ e => FormatPhone(e, setActivationData) }
                      autoComplete = "off"
                      maxLength={60}
                      className={CheckError("phone") ? 'error' : ''}
                    />
                    <span className='errorMessage'>{CheckError("phone") ? CheckError("phone") : ''}</span>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup>
                    <label className="subTitle">* Activation Code: </label>
                    <Input
                      placeholder="Activation Code"
                      type="text"
                      name="code"
                      value={activationdata.code}
                      onChange={ e => UpdateActivationData(e) }
                      autoComplete = "off"
                      maxLength={60}
                      className={CheckError("referral") ? 'error' : ''}
                    />
                    <span className='errorMessage'>{CheckError("code") ? CheckError("code") : ''}</span>
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          }

          {step === 2 &&
            <Row>
              <Col md="12">
                <h4 style={{padding:"20px"}}>Your WOW Cloud Storage has been activated. You will receive an email with your login credentials and how to access your WOW Cloud Storage account.</h4>
              </Col>
            </Row>
          }

          {step === 1 &&
            <CardFooter>
              <Button 
                className="btn-fill mwbtn" 
                color="info" 
                type="button" 
                style={{width:"100%"}}
                onClick = {() => ActivateNow()}
                >
                  Activate Now
              </Button>
            </CardFooter>
          }
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Activation; 
